export default "__VITE_ASSET__267d56dc__"